import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { IonicModule } from '@ionic/angular';

import { SocialLoginComponent } from './social-login/social-login.component';


@NgModule({
  declarations: [
    SocialLoginComponent
  ],
  exports: [
    SocialLoginComponent
  ],
  imports: [
    IonicModule,
    SharedModule
  ]
})
export class AuthSharedModule { }
